import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vc-modal-delivery-service-description',
  templateUrl: './modal-delivery-service-description.component.html',
  styleUrls: ['./modal-delivery-service-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalDeliveryServiceDescriptionComponent implements OnInit {
  private dsPromoPerRegion = {
    FR: { voucher: '15€', toptierLimit: '1000€' },
    US: { voucher: '$20', toptierLimit: '$1000' },
    UK: { voucher: '£10', toptierLimit: '£1000' },
    DE: { voucher: '15€', toptierLimit: '1000€' },
    ES: { voucher: '15€', toptierLimit: '1000€' },
    IT: { voucher: '15€', toptierLimit: '1000€' },
    DK: { voucher: '100DKK', toptierLimit: '7500DKK' },
    FI: { voucher: '15€', toptierLimit: '1000€' },
    SE: { voucher: '150SEK', toptierLimit: '1000SEK' },
    WW: { voucher: '$20', toptierLimit: '$1000' },
    ROE: { voucher: '15€', toptierLimit: '1000€' },
    SG: { voucher: 'S$25', toptierLimit: 'S$1500' },
    HK: { voucher: 'HK$150', toptierLimit: 'HK$9000' },
    AU: { voucher: 'AU$60', toptierLimit: 'AU$1500' }
  };
  public dsPromo = this.dsPromoPerRegion['FR'].voucher;
  public topTierLimit = this.dsPromoPerRegion['FR'].toptierLimit;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    if (data && data.region && this.dsPromoPerRegion.hasOwnProperty(data.region)) {
      this.dsPromo = this.dsPromoPerRegion[data.region].voucher;
      this.topTierLimit = this.dsPromoPerRegion[data.region].toptierLimit;
    }
  }

  ngOnInit() {}
}
